(function($) {

	'use strict';

	var init = function() {

        ToggleLightboxGallery();
        ToggleLightboxSimple();
	};

    var ToggleLightboxGallery = function() {
        //---Start each lightbox & carousel with MAIN button
        $('.flex-gallery').each(function(index) {
            StartLightboxGallery(index);
        });
    }

    var StartLightboxGallery = function(index) {

        var top = 0;

        $('.modal__g-start:eq(' + index + ')').on('click', function() {
            $('.modal--gallery:eq(' + index + ') .modal__img').each(function() {
                $(this).attr('src', $(this).data('src'));
            });
            $('.modal__carousel:eq(' + index + ')').owlCarousel({
                center: true,
                margin: 50,
                items: 1,
                loop: true
            });
            setTimeout(function() {
                $('.modal--gallery:eq(' + index + ')').addClass('active');
                top = $(window).scrollTop();
                $('body').addClass('open');
                $('body').scrollTop(top);
            }, 300);
        });
        $('.flex-gallery:eq(' + index + ') .modal__g-open').each(function() {
            $(this).on('click', function() {
                $('.modal--gallery:eq(' + index + ') .modal__img').each(function() {
                    $(this).attr('src', $(this).data('src'));
                });
                var start = parseInt($(this).data('index')) - 1;
                $('.modal__carousel:eq(' + index + ')').owlCarousel({
                    center: true,
                    margin: 50,
                    items: 1,
                    loop: true,
                });
                $('.modal__carousel:eq(' + index + ')').trigger('to.owl.carousel', start);
                setTimeout(function() {
                    $('.modal--gallery:eq(' + index + ')').addClass('active');
                    top = $(window).scrollTop();
                    $('body').addClass('open');
                    $('body').scrollTop(top);
                }, 400);
            });
        });
        $('.modal__g-close:eq(' + index + ')').on('click',function() {
            $('.modal--gallery:eq(' + index + ')').removeClass('active');
            $('body').removeClass('open');
            $('html, body').scrollTop(top);
        });
        $('.modal--gallery:eq(' + index + ')').on('click',function() {
            $('.modal--gallery:eq(' + index + ')').removeClass('active');
            $('body').removeClass('open');
            $('html, body').scrollTop(top);
        });
        $('.modal__carousel').on('click', function(e) {
            e.stopPropagation();
        });
        $('.modal__nav').on('click', function(e) {
            e.stopPropagation();
        });
        $('.prev:eq(' + index + ')').on('click', function() {
            $('.modal__carousel:eq(' + index + ')').trigger('prev.owl.carousel');
        });
        $('.next:eq(' + index + ')').on('click', function() {
            $('.modal__carousel:eq(' + index + ')').trigger('next.owl.carousel');
        });
    }

    var ToggleLightboxSimple = function() {

        var top = 0;

        $('.lightbox--simple').each(function(index) {
            $('.lightbox__open:eq(' + index + ')').on('click', function() {
                $('.lightbox__img:eq(' + index + ')').attr('src', $('.lightbox__img:eq(' + index + ')').data('src'));
                $('.lightbox__full:eq(' + index + ')').addClass('active');
                top = $(window).scrollTop();
                $('body').addClass('open');
                $('body').scrollTop(top);
            })
            $('.lightbox__close:eq(' + index + ')').on('click',function() {
                $('.lightbox__full:eq(' + index + ')').removeClass('active');
                $('body').removeClass('open');
                $('html, body').scrollTop(top);
            });
            $('.lightbox__full:eq(' + index + ')').on('click',function() {
                $('.lightbox__full:eq(' + index + ')').removeClass('active');
                $('body').removeClass('open');
                $('html, body').scrollTop(top);
            });
            $('.lightbox__fig').on('click', function(e) {
                e.stopPropagation();
            });
        })
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);
